import { render, staticRenderFns } from "./BarCode.vue?vue&type=template&id=35508328&scoped=true&"
import script from "./BarCode.vue?vue&type=script&lang=js&"
export * from "./BarCode.vue?vue&type=script&lang=js&"
import style0 from "./BarCode.vue?vue&type=style&index=0&id=35508328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35508328",
  null
  
)

export default component.exports